import React from 'react';
import { useSelector } from 'react-redux';
import ClassNames from 'classnames';

import { Icon } from '@pwc/pwc-deals-ui';
import { CommentTarget, CommentType } from '@pwc/pwc-deals-web-common';
import { getIsDarkModeSelector } from '../../redux/userSettings/userSettingsSlice';
import CalloutBoxCopy from './CalloutBoxCopy';
import RichTextReadOnlyComment from '../RichTextForm/RichTextReadOnlyComment';
import styles from './CalloutBox.module.scss';

function CalloutBox({
  iconName,
  iconClass = 'icon fill icon-grey-theme',
  text,
  headerLabel,
  dataTestId,
  usage,
  enableInlineComment = false,
  commentTarget = CommentTarget.Description,
}) {
  const darkMode = useSelector(getIsDarkModeSelector);
  return (
    <div
      className={ClassNames(
        styles['callout-box'],
        darkMode
          ? styles['callout-box--dark-theme']
          : styles['callout-box--light-theme'],
        usage === 'summary' ? styles['callout-box--summary'] : undefined,
        usage === 'detail' ? styles['callout-box--detail'] : undefined
      )}
      data-testid={dataTestId}
    >
      <div className={styles['callout-box__header']}>
        <Icon name={iconName} className={iconClass} width={18} height={18} />
        <span aria-label={headerLabel}>{headerLabel}</span>
      </div>
      {!enableInlineComment && <CalloutBoxCopy fullCopy={text} />}
      {enableInlineComment && (
        <RichTextReadOnlyComment
          richText={text}
          commentType={CommentType.RichText}
          commentTarget={commentTarget}
          libraryItemId={commentTarget}
        />
      )}
    </div>
  );
}

export default CalloutBox;
